import { FormInstanceElement } from "../form-builder/form-instance-element.model"
import { ChangedSelectionFieldValues } from "./changed-selection-field-values.model";

export class SelectionFieldValueChangeInstructions {
    public fieldNames: any;
    public sourceFieldDisplayName: string;
    public sourceFieldName: string;
    public sourceFieldValue: string[];
    public fieldIdsToSelectedValues: any;

    public id: number;
    public formInstanceElement: FormInstanceElement;
    public fieldSelectableValues: ChangedSelectionFieldValues[] = [];
}
